"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var deviceAtmosphere_type_1 = require("./deviceAtmosphere.type");
var PREFIX_HIKVISION = "HI_DS_05_";
var PREFIX_TERARANGER = "TB_TR_01_";
var PREFIX_TERABEE_CAMERA = "TB_CL_01_";
exports.isHikvision = function (padId) { return padId.startsWith(PREFIX_HIKVISION); };
exports.isTeraRanger = function (padId) { return padId.startsWith(PREFIX_TERARANGER); };
exports.isTerabeeCamera = function (padId) { return padId.startsWith(PREFIX_TERABEE_CAMERA); };
exports.isCameraDevice = function (padId) { return exports.isHikvision(padId) || exports.isTerabeeCamera(padId) || exports.isTeraRanger(padId); };
exports.isTechnisPad = function (padId) { return !exports.isCameraDevice(padId) && !deviceAtmosphere_type_1.isAtmosphereDevice(padId); };
exports.isCountingDevice = function (padId) { return exports.isTechnisPad(padId) || exports.isCameraDevice(padId); };
